import React from 'react';

const ErrorView = (props) => {
    return (
        <div style={{ margin: '1.6rem', fontSize: 'large' }}>
            <div>
                <div>
                    <h1>OP</h1>
                </div>
                <div>
                    <div>
                        <h2>H&auml;iri&ouml; palvelussa, pahoittelemme</h2>
                    </div>
                    <div>
                        <p>
                            OP-verkkopalvelu ei juuri nyt ole k&auml;ytett&auml;viss&auml;. Pahoittelemme h&auml;iri&ouml;st&auml; aiheutuvaa
                            k&auml;yt&ouml;n katkosta. Ole hyv&auml; ja yrit&auml; uudelleen hetken kuluttua.
                        </p>
                    </div>
                </div>
                <div>
                    <hr />
                    <p>
                        <strong>St&ouml;rning i tj&auml;nsten, vi beklagar</strong>
                        <br />
                        OP-n&auml; ttj&auml;nsten &auml;r inte tillg&auml;nglig just nu. Vi beklagar avbrottet som st&ouml;rningen f&ouml;rorsakar.
                        Var god och f&ouml;rs&ouml;k p&aring; nytt om en stund.
                    </p>
                </div>
                <div>
                    <hr />
                    <p>
                        <strong>We are sorry, there is a disruption in our service</strong>
                        <br />
                        OP eServices are temporarily unavailable. We apologise for interruptions in use caused by this disruption. Please try again
                        soon.
                    </p>
                </div>
                <div>
                    <hr />
                    <p>&#169; OP Pohjola</p>
                </div>
            </div>
        </div>
    );
};

export default ErrorView;
